<footer [class.bg-white]="background == 'white'">

    <div class="container footer-inner">
        
        <div class="row align-items-center">
            
            <div class="col-12 col-md-5">
                <span class="smaller copyright">© <span id="year">{{currentDate | date:'yyyy'}}</span> skillconomy</span>
            </div>

            <div class="col-12 col-md-7">
                
              <ul class="nav smaller justify-content-md-end">
                <li class="nav-item">
                  <a class="nav-link hover" (click)="showModal(imprintModal, 'lg');">Impressum</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link hover" (click)="showModal(privacyModal, 'lg');">Datenschutz</a>
                </li>
              </ul>

            </div>

        </div>

    </div>
    
</footer>


<ng-template #imprintModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h2 class="modal-title">Impressum</h2>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
        
        <p>
            <strong>skillconomy GmbH</strong><br>
            Werkstättenstr. 18<br>
            51379 Leverkusen
        </p>

        <p>
            <a class="phone" href="tel:+4921717767670"><fa-icon [icon]="['fas', 'mobile-alt']" class="mr-2"></fa-icon> +49-2171-77 67 67 0</a><br>
            <a class="email" href="mailto:info@skillconomy.com"><fa-icon [icon]="['fas', 'envelope']" class="mr-2"></fa-icon> info@skillconomy.com</a>
        </p>

        <h4>Geschäftsführer:</h4>
        <p>Lars Branscheid, Marc Branscheid, Jonas Krömer<br>
        Amtsgericht Bochum | HRB 15517</p>

        <h4>Verantwortlich für den Inhalt nach §55 Abs. 2 RStV:</h4> 
        <p>Lars Branscheid.</p>

        <h4>1. Haftungsbeschränkung</h4>
        <p>Die Webseite wurde mit größtmöglicher Sorgfalt erstellt. Der Anbieter dieser Webseite übernimmt dennoch keine Gewähr für die Richtigkeit, Vollständigkeit und Aktualität der bereitgestellten Inhalte und Informationen. Die Nutzung der Webseiteninhalte erfolgt auf eigene Gefahr. Allein durch die Nutzung der Website kommt keinerlei Vertragsverhältnis zwischen dem Nutzer und dem Anbieter zustande.</p>

        <h4>2. Verlinkungen</h4>
        <p>Die Webseite enthält Verlinkungen zu anderen Webseiten ("externe Links"). Diese Webseiten unterliegen der Haftung der jeweiligen Seitenbetreiber. Bei Verknüpfung der externen Links waren keine Rechtsverstöße ersichtlich. Auf die aktuelle und künftige Gestaltung der verlinkten Seiten hat der Anbieter keinen Einfluss. Die permanente überprüfung der externen Links ist für den Anbieter ohne konkrete Hinweise auf Rechtsverstöße nicht zumutbar. Bei Bekanntwerden von Rechtsverstößen werden die betroffenen externen Links unverzüglich gelöscht.</p>

        <h4>3. Urheberrecht / Leistungsschutzrecht</h4>
        <p>Die auf dieser Webseite durch den Anbieter veröffentlichten Inhalte unterliegen dem deutschen Urheberrecht und Leistungsschutzrecht. Alle vom deutschen Urheber- und Leistungsschutzrecht nicht zugelassene Verwertung bedarf der vorherigen schriftlichen Zustimmung des Anbieters oder jeweiligen Rechteinhabers. Dies gilt vor allem für Vervielf#ltigung, Bearbeitung, Übersetzung, Einspeicherung, Verarbeitung bzw. Wiedergabe von Inhalten in Datenbanken oder anderen elektronischen Medien und Systemen. Dabei sind Inhalte und Rechte Dritter als solche gekennzeichnet. Das unerlaubte Kopieren der Webseiteninhalte oder der kompletten Webseite ist nicht gestattet und strafbar. Lediglich die Herstellung von Kopien und Downloads für den persönlichen, privaten und nicht kommerziellen Gebrauch ist erlaubt.</p>

        <p>Diese Website darf ohne schriftliche Erlaubnis nicht durch Dritte in Frames oder iFrames dargestellt werden.</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="d('Cross click')">Schließen</button>
  </div>
</ng-template>

<ng-template #privacyModal let-c="close" let-d="dismiss">

    <div class="modal-header">
    
      <h4 class="modal-title">Datenschutz</h4>
    
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    
    </div>

    <div class="modal-body">

          <p><a href="https://portal.skillconomy.com/downloads/datenschutzerkl%C3%A4rung_skillconomy.pdf" target="_blank"><fa-icon [icon]="['fas', 'file-download']" class="mr-2"></fa-icon> Datenschutzerklärung (PDF)</a></p>

          <p>Mit dem Besuch dieser Webseite können Informationen über den Zugriff gespeichert werden. Diese Daten wie Uhrzeit, Datum und die betrachtete Seite gehören nicht zu den personenbezogenen Daten, sondern sind anonymisiert. Dies werden nur aus statistischen Zwecken erfasst. Eine Weitergabe an Dritte, zu kommerziellen oder nichtkommerziellen Zwecken, erfolgt nicht. Um dem Nutzer unsere Angebote individueller zur Verfügung stellen und auf seine Bedürfnisse anpassen zu können, kommen auf unserer Website Cookies zum Einsatz, über die ein Kunde für die Dauer seines Besuchs wiedererkannt werden kann. Ein Cookie ist eine kleine Textdatei, die von WWW-Servern beim Besuch einer Internetseite verschickt wird. Diese Cookies dienen dazu, das Online-Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Die Cookies enthalten keine personenbezogene Daten bzw. keinerlei persönliche Informationen, so dass eine Identifizierung des Nutzers allein mit den anhand der Cookies gewonnenen Informationen nicht möglich ist.</p>

          <p>Der Anbieter weist ausdrücklich darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen und nicht lückenlos vor dem Zugriff durch Dritte geschützt werden kann.</p>

          <p>Die Verwendung der Kontaktdaten des Impressums zur gewerblichen Werbung ist ausdrücklich nicht erwünscht, es sei denn der Anbieter hatte zuvor seine schriftliche Einwilligung erteilt oder es besteht bereits eine Geschäftsbeziehung. Der Anbieter und alle auf dieser Website genannten Personen widersprechen hiermit jeder kommerziellen Verwendung und Weitergabe ihrer Daten.</p>

          <p>Quelle: Disclaimer Vorlage powered by <a href="https://www.fachanwalt.de" target="_blank">fachanwalt.de</a></p>
          
      
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="d('Cross click')">Schließen</button>
    </div>
</ng-template>